var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45364 10.1754V12.9854C3.45364 13.7154 3.85364 14.3954 4.49364 14.7454L9.49364 17.4754C10.0936 17.8054 10.8136 17.8054 11.4136 17.4754L16.4136 14.7454C17.0536 14.3954 17.4536 13.7154 17.4536 12.9854V10.1754L11.4136 13.4754C10.8136 13.8054 10.0936 13.8054 9.49364 13.4754L3.45364 10.1754ZM9.49364 0.515391L1.06364 5.11539C0.373643 5.49539 0.373643 6.49539 1.06364 6.87539L9.49364 11.4754C10.0936 11.8054 10.8136 11.8054 11.4136 11.4754L19.4536 7.08539V12.9954C19.4536 13.5454 19.9036 13.9954 20.4536 13.9954C21.0036 13.9954 21.4536 13.5454 21.4536 12.9954V6.58539C21.4536 6.21539 21.2536 5.88539 20.9336 5.70539L11.4136 0.515391C10.8136 0.195391 10.0936 0.195391 9.49364 0.515391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school-icon.b5e9012d530c03b3c597529733076af3.svg";
export { ForwardRef as ReactComponent };